module.exports = __webpack_public_path__ + "img/manage-img2.5be1195e.png";